<p>data-group-matrix-generic works!</p>
